import { ItemsType } from "@veneer/core";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import { useTranslation } from "react-i18next";


const GetBreadCrumbsRoutes = (prop: any) => {
    const [t] = useTranslation("global");

    const breadCrumbsRoutes = new Map<number, ItemsType[]>([
        [BreadCrumbsEnum.Agenda, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
        ],],
        [BreadCrumbsEnum.Activities, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.ShareOfShelf, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: 'Share of shelf',
                url: `/PosManagerWeb/shareOfShelf${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.ESFCoverage, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.esfCoverageTitle"),
                url: `/PosManagerWeb/esfCoverageAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]]
        ,
        [BreadCrumbsEnum.Survey, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.surveys"),
                url: `/PosManagerWeb/surveyByAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]]
        ,
        [BreadCrumbsEnum.VisualInventory, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.visualExecutionInventory"),
                url: `/PosManagerWeb/visualExecutionInventory${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.Inventory, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.inventory"),
                url: `/PosManagerWeb/inventoryAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.Sales, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.sales"),
                url: `/PosManagerWeb/salesAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.PriceShopping, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.prices"),
                url: `/PosManagerWeb/pricesAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.POSLayout, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.posLayoutTitle"),
                url: `/PosManagerWeb/posLayoutAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.Feedback, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: 'FeedBack',
                url: `/PosManagerWeb/feedBack${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.ClosingSales, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.closingSales"),
                url: `/PosManagerWeb/closingSalesAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.StockOut, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.stockOut"),
                url: `/PosManagerWeb/stockOutAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
        [BreadCrumbsEnum.ServedClients, [
            {
                text: t("header.agenda"),
                url: '/PosManagerWeb/agendas',
            },
            {
                text: t("header.activities"),
                url: `/PosManagerWeb/activitiesByAppointment${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
            {
                text: t("header.servedClientsTittle"),
                url: `/PosManagerWeb/servedClientsAppointment${prop.appointmentActivityId > 0 && `/${prop.appointmentActivityId}`}${prop.activityId > 0 && `/${prop.activityId}`}`,
            },
        ]],
    ]);
    return breadCrumbsRoutes.get(prop.route);
}


export default GetBreadCrumbsRoutes;


